export const notfData = {
title:"Benachrichtigungen"
};